module.exports = __webpack_public_path__ + "img/logo-y-p.fbc3876d3d3026a32258da3b99bfc19c.svg";